require("./polyfills");

module.exports = require('./dom-helper');